const RetreatDetailsSection = () => {
  return (
    <section id="retreat-details" className="py-24 bg-sage-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div 
              className="w-full h-96 lg:h-[32rem] rounded-3xl bg-cover bg-center shadow-2xl"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/8de4aed02f08a35a4b134d6f9a15c5b7.jpg')`
              }}
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 text-white">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-12">
              Retreat Details
            </h2>

            <div className="space-y-8">
              {/* Duration */}
              <div>
                <h3 className="text-sm uppercase tracking-wider text-sand-200 font-semibold mb-2">
                  Duration
                </h3>
                <p className="text-xl text-white">
                  3 Nights / 4 Days
                </p>
              </div>

              {/* Accommodation */}
              <div>
                <h3 className="text-sm uppercase tracking-wider text-sand-200 font-semibold mb-2">
                  Accommodation
                </h3>
                <p className="text-xl text-white">
                  Comfortable, serene spaces designed for rest and rejuvenation
                </p>
              </div>

              {/* Meals */}
              <div>
                <h3 className="text-sm uppercase tracking-wider text-sand-200 font-semibold mb-2">
                  Meals
                </h3>
                <p className="text-xl text-white">
                  Fresh, sattvic, Ayurvedic-inspired cuisine crafted to nourish your body and soul
                </p>
              </div>

              {/* Included Activities */}
              <div>
                <h3 className="text-sm uppercase tracking-wider text-sand-200 font-semibold mb-2">
                  Included Activities
                </h3>
                <div className="text-xl text-white">
                  <p className="mb-4">Comprehensive wellness experiences including:</p>
                  <ul className="space-y-2 text-lg">
                    <li className="flex items-start">
                      <i className="ri-check-line text-gold-400 mt-1 mr-3 flex-shrink-0"></i>
                      <span>Daily Yoga & Pranayama sessions</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-gold-400 mt-1 mr-3 flex-shrink-0"></i>
                      <span>Guided Meditation practices</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-gold-400 mt-1 mr-3 flex-shrink-0"></i>
                      <span>Personalized Ayurvedic Treatments</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-gold-400 mt-1 mr-3 flex-shrink-0"></i>
                      <span>Anahata Focus heart-centered practices</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-gold-400 mt-1 mr-3 flex-shrink-0"></i>
                      <span>Mindful Movement & nature immersion</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-gold-400 mt-1 mr-3 flex-shrink-0"></i>
                      <span>Water-based healing experiences</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Investment */}
              <div className="pt-6 border-t border-sage-400">
                <h3 className="text-sm uppercase tracking-wider text-sand-200 font-semibold mb-4">
                  Investment in Your Wellness
                </h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-xl font-semibold text-white">Shared Room</p>
                      <p className="text-sm text-sand-200">All-inclusive retreat experience</p>
                    </div>
                    <p className="text-2xl font-bold text-gold-300">€1,500</p>
                  </div>
                  <div className="flex justify-between items-center pt-4 border-t border-sage-400/50">
                    <div>
                      <p className="text-xl font-semibold text-white">Private Room</p>
                      <p className="text-sm text-sand-200">Exclusive personal space</p>
                    </div>
                    <p className="text-2xl font-bold text-gold-300">€1,800</p>
                  </div>
                </div>
                <p className="text-base text-sand-200 mt-6">
                  Includes expert guidance, accommodation, all meals, and every activity. A 50% deposit secures your place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RetreatDetailsSection;